<template>
  <div>
    <el-dialog title="活动推广"
               :visible.sync="dialogFormVisible"
               @close="emitClose"
               @open="open"
               :close-on-click-modal="false"
               width="460px">
      <div>
        <div id="qrcode"
             ref="qrcode"></div>
        <div class="urlLink"
             v-if="erCode"> <el-link type="primary"
                   @click="dowload">下载二维码</el-link></div>
        <div class="linkInput">
          <el-input v-model="linkCode"
                    style="width:300px;"></el-input>
          <div class="copyLink type"
               :data-clipboard-text="clipboardText"
               @click="copyLink">复制链接</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createMiniProgram } from '@/api/operation'
import QRCode from 'qrcodejs2'
import Clipboard from 'clipboard'
export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
        sort: 0,
        hot_status: 0,
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      clipboardText: '',
      fileList: [],
      codeLink: '',
      erCode: '',
      linkCode: '',
      qrcode: null,
      short_code: '',
    }
  },
  mounted() {},
  created() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    content(val) {
      if (val) {
        console.log('拿到图片', val)
        this.short_code = val.short_code
        this.linkCode = `https://h5.kaoyanbox.com/promation/${val.short_code}`
        if (val.ref_img_urls != '') {
          this.erCode = this.getRandomImage(val.ref_img_urls.split(','))
          this.codeLink = this.erCode
        } else {
          this.codeLink = val.ref_redirect_url
        }
        this.generateQRCode()
        console.log('this.erCode', this.erCode)
      }
    },
  },
  methods: {
    copyLink() {
      this.clipboardText = this.linkCode
      var clipboard = new Clipboard('.type')
      clipboard.on('success', (e) => {
        this.$message({
          message: '复制成功！',
          type: 'success',
        })
        this.handleToClose()
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        this.$message({
          message: '该浏览器不支持自动复制',
          type: 'error',
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    open() {},
    async dowload() {
      const canvas = this.$refs.qrcode.querySelector('canvas')
      if (!canvas) return

      const link = document.createElement('a')
      link.download = 'qrcode.png'
      link.href = canvas.toDataURL('image/png')
      link.click()
    },
    //生成二维码
    generateQRCode() {
      // 清除之前的二维码
      if (this.qrcode) {
        this.$refs.qrcode.innerHTML = ''
      }
      // 生成新的二维码
      setTimeout(() => {
        this.qrcode = new QRCode(this.$refs.qrcode, {
          text: this.linkCode,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        })
      }, 500)
    },
    // 随机选择一张图片
    getRandomImage(imagesArray) {
      const randomIndex = Math.floor(Math.random() * imagesArray.length)
      return imagesArray[randomIndex]
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url,
      })
    },
    emitClose() {
      this.dataForm = {
        sort: 0,
        hot_status: 0,
      }
      this.fileList = []
      this.$emit('close')
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            name: this.dataForm.name,
            appid: this.dataForm.appid,
            icon_url: this.fileList
              .map((v) => {
                return v.url
              })
              .join(','),
            description: this.dataForm.description,
            origin_id: this.dataForm.origin_id,
            redirect_url: this.dataForm.redirect_url,
            hot_status: this.dataForm.hot_status,
            sort: this.dataForm.sort,
          }
          createMiniProgram(query).then((res) => {
            this.$message.success(`添加成功`)
            this.$emit('submit')
            this.emitClose()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5 !important;
}
.warn {
  font-weight: 400;
  font-size: 12px;
  color: #c0c4cc;
}
.erCode {
  width: 350px;
  height: 350px;
  img {
    width: 100%;
    height: 100%;
  }
}
.urlLink {
  margin-top: 10px;
}
.linkInput {
  margin-top: 19px;
  width: 380px;
  height: 32px;
  display: flex;
  .copyLink {
    cursor: pointer;
    color: #fff;
    text-align: center;
    width: 80px;
    line-height: 30px;
    background: #1f86fe;
  }
}
</style>